export default "__VITE_ASSET__BH2aX6KK__"